const RANK_CONSTANT = 0.035;

(function() {
    game.services.user = {
        currentUser: null,
        wallets: null,
        calculateRank: function(xp) {
            return Math.floor(RANK_CONSTANT * Math.sqrt(xp));
        },
        login: function(type, loginData, component) {
            if (game.isPlayScreen && !game.isInMenu) {
                return;
            }

            if (Cookies.get('token')) {
                return;
            }

            let playerName = '';
            if (window.localStorage) {
                playerName = window.localStorage.getItem('name');
            }

            var data = {
                type: type,
                playerName: playerName
            };
            data = Object.assign(data, loginData);

            if (window.ga) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Lobby',
                    eventAction: 'signIn'
                });
            }

            return axios.post(API_URL + '/login', data).then((res) => {
                let data = res.data;
                if (data.success) {
                    Cookies.set('token', data.data.session, {
                        expires: 365,
                        sameSite: window.location.hostname !== 'localhost' ? 'None' : 'Lax',
                        secure: window.location.hostname !== 'localhost'
                    });
                    game.services.user.initUser(component);
                    //component.$root.$emit('changeState', 'state-play');
                    window.location.reload();
                } else {
                    let message = 'Failed to login.';
                    if (data.error) {
                        if (data.error.message) {
                            message = data.error.message;
                        } else {
                            message = data.error;
                        }
                    } else if (data.message) {
                        message = data.message;
                    }
                    game.showGrowl(message, {type: 'danger'});
                    throw new Error(message);
                }
            }, (err) => {
                game.showGrowl('Failed to connect to server for login.', {type: 'danger'});
            });
        },
        logout: function() {
            if (window.ga) {
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'Lobby',
                    eventAction: 'signOut'
                });
            }

            try {
                var auth2 = gapi.auth2.getAuthInstance();
                auth2.signOut().then(function () {
                    Cookies.remove('token');
                    window.location.reload();
                }, function() {
                    Cookies.remove('token');
                    window.location.reload();
                });
            } catch (e) {
                Cookies.remove('token');
                window.location.reload();
            }
        },
        initUser: function(component) {
            if (game.isPlayScreen) {
                return Promise.resolve();
            }

            let token = Cookies.get('token');
            if (token) {
                return axios.get(API_URL + '/session?token=' + token).then((res) => {
                    let data = res.data;
                    if (data && data.session && data.session.userId) {
                        game.services.user.currentUser = data.user;
                        game.services.user.currentUser.coinCount = 0;
                        game.services.user.currentUser.currentRank = 0;
                        game.services.user.currentUser.nextRankPercentage = 0;

                        if (game.services.user.currentUser && game.services.user.currentUser.roles) {
                            let roles = game.services.user.currentUser.roles.split(',');
                            if (roles.indexOf('ROLE_SUPER_ADMIN') !== -1) {
                                game.services.user.currentUser.isDev = true;
                            }
                        }

                        if (game.services.user?.currentUser?.isDev) {
                            game.services.socket.connectMenuSocket(component);
                        }

                        component.$root.$emit('signIn');

                        if (game.loadStripe) {
                            game.loadStripe();
                        }

                        axios.get(API_URL + '/settings?token=' + token);

                        return axios.get(API_URL + '/wallets?token=' + token).then((res) => {
                            let data = res.data;
                            if (data.success && data.data && data.data.data) {
                                game.services.user.wallets = data.data.data;

                                for (let i=0; i<game.services.user.wallets.length; i++) {
                                    let wallet = game.services.user.wallets[i];
                                    if (wallet.currency.slug === 'coins') {
                                        game.services.user.currentUser.coinCount = wallet.amount;
                                    } else if (wallet.currency.slug === 'xp') {
                                        let rankRaw = RANK_CONSTANT * Math.sqrt(wallet.amount);
                                        let rank = Math.floor(rankRaw);
                                        let nextRank = rankRaw - rank;
                                        game.services.user.currentUser.currentXp = wallet.amount;
                                        game.services.user.currentUser.currentRank = rank;
                                        game.services.user.currentUser.nextRankPercentage = Math.floor(nextRank*100);
                                    }
                                }
                            }
                        });
                    } else {
                        Cookies.remove('token');
                    }
                }, function () {
                    Cookies.remove('token');
                });
            }
        }
    };
})();